import {Pill, TextSmallMedium, Tooltip} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'
import {v4 as uuidv4} from 'uuid'
interface BrickCalculationPatternProps {
  brickShape1: string
  layingPattern: string[]
}
export const BrickCalculationPattern = ({
  brickShape1,
  layingPattern
}: BrickCalculationPatternProps) => {
  const uuid = uuidv4()
  const {t} = useTranslation()

  return (
    <div className="flex flex-col gap-2">
      <TextSmallMedium>{t('refraPlanning.brickCalculation.layingPattern')}</TextSmallMedium>
      <div className="flex flex-row">
        {layingPattern.map((pattern, index) => (
          <Tooltip content={pattern} key={`tooltip-${uuid}-${index}`}>
            <Pill
              size="regular"
              key={`pattern-${uuid}-${index}`}
              type={pattern === brickShape1 ? 'primary' : 'neutral'}
              text={pattern === brickShape1 ? '1' : '2'}
            />
          </Tooltip>
        ))}
      </div>
    </div>
  )
}
